<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Faktura" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<select-view label="Afdeling" v-model="entity.department_id" :options="departments" optionValueName="id" />
				</div>
				<div v-show="active == 'details'">
					<date-select-view label="Faktureret" v-model="entity.created" :controller="$store.state.popupController" :suggestions="[]" />
					<date-select-view label="Forfalder" v-model="entity.due" :controller="$store.state.popupController" :suggestions="[]" />
				</div>
				<div v-show="active == 'details'">
					<text-view label="Bemærkninger" v-model="entity.remarks" :height="400" :optional="true" />
				</div>
				<div v-show="active == 'details'" v-if="false">
					<div class="side-window__heading">
						Send e-mail ved godkendelse
						<switch-view v-model="entity.email_on_post" />
					</div>
				</div>
				<div v-show="active == 'customer' && entity._embedded.contact && entity._embedded.contact.details && entity._embedded.contact.details != ''">
					<info-view>{{ entity._embedded.contact ? entity._embedded.contact.details : '' }}</info-view>
				</div>
				<div v-show="active == 'customer'">
					<contact-select-view v-model="entity" label="Kunde" :optional="true" @select="selectCustomer" />
				</div>
				<div v-show="active == 'customer'">
					<string-view label="Telefon" v-model="entity.customer.phone" :optional="true" />
					<string-view label="E-mail" v-model="entity.customer.email" :optional="true" />
				</div>
				<div v-show="active == 'customer'">
					<string-view label="Navn" v-model="entity.customer.name" />
					<string-view label="Att." v-model="entity.customer.att" :optional="true" />
				</div>
				<address-view v-show="active == 'customer'" v-model="entity.customer.address" />
				<div v-show="active == 'order'">
					<order-view :hours="_hours" v-model="entity.order_lines" :altPrices="prices" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem og send til e-conomics" @click="onAddButtonClick(true)" />
			<button-view label="Gem" @click="onAddButtonClick(false)" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import ContactSelectView from '../views/ContactSelectView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import TaskListView from '../views/TaskListView';
	import AddressView from '../views/AddressView';
	import ApprovalView from '../views/ApprovalView';

	import OrderModel from '../model/Order'
	import ContactModel from '../model/Contact'

	import merge from '../functions/merge'

	import ContextPopupView from '../views/ContextPopupView'

	import InvoiceWindow from '../windows/InvoiceWindow';

	import { bus } from '../../bus'

	export default {
		data: function () {
			return {
				hours: [],
				//packaging: [],
				//ORDER: [],
				email: false,
				orders: [],
				template: {
					template: ''
				},
				entity: {
					department_id: null,
					email_on_post: false,
					contact_id: null,
					remarks: '',
					order_lines: [],
					template: '',
					created: (new Date()).format('Y-m-d'),
					due: (new Date()).format('Y-m-d'),
					customer: {
						name: '',
						att: '',
						email: '',
						phone: '',
						address: {
							zip: '',
							city: '',
							address: '',
							country: ''
						}
					},
					_embedded: {
						contact: {
							name: '',
							address: '',
							zip: '',
							city: ''
						}
					}
				},

				prices: [],
				active: 'details',
				//instructions: [],
				departments: [],
				staticNumbers: [
					{
						name: 'vat',
						label: 'CVR',
						default: ''
					},
					{
						name: 'ean',
						label: 'EAN',
						default: ''
					}
				],
				numbers: [],
				status: [],
				templates: []
				//motivations: [],
				//tasks: []
			};
		},
		watch: {
			from(newVal) {
				this.to = newVal;
			}
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'ContactSelectView': ContactSelectView,
			'TaskListView': TaskListView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView,
			'ApprovalView': ApprovalView
		},
		computed: {
			_hours() {
				return this.hours;
			},
			_hour_warning() {
				// Has hour task
				var hourTask = false;

				for (var i = 0; i < this.entity._embedded.tasks.length; ++i) {
					var t = this.entity._embedded.tasks[i];

					if (t.hour_rate > 0) {
						hourTask = true;
						break;
					}
				}

				// Has hours line
				var hourLine = false;

				for (i = 0; i < this.entity.order_lines.length; ++i) {
					var l = this.entity.order_lines[i];

					if (l.unit == 'timer') {
						hourLine = true;
						break;
					}
				}

				// Return
				return hourTask && !hourLine;
			},
			tabs: function () {
				var r = [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'customer',
						label: 'Kunde'
					},
					{
						name: 'order',
						label: 'Pris'
					}
				];

				return r;
			},
			_template() {
				var self = this;
				return this.templates.find(function (item) { return item.id == self.entity.template_id; });
			},
			_lines() {
				return this._template ? this._template.incl.split("\n") : [];
			},
			_numbers() {
				var r = [];

				for (var i = 0; i < this.staticNumbers.length; ++i) {
					r.push(this.staticNumbers[i]);
				}

				for (i = 0; i < this.numbers.length; ++i) {
					r.push(this.numbers[i]);
				}

				// Add to entity
				var ent = this.entity;
				
				for (i = 0; i < r.length; ++i) {
					if (!ent.customer.numbers.hasOwnProperty(r[i].name)) {
						ent.customer.numbers[r[i].label] = r[i].default;
					}
				}

				

				return r;
			},
			_actions() {
				const self = this;

				return [
					{
						label: 'Åben',
						action() {
							

							// Set invoice date
							//this.invoiced = 'true';

							self.submit(merge({}, self.entity), false, 'open'); 
						}
					},
					{
						label: 'Send til e-conomic (faktureret)',
						action() {
							//alert('Varenumre mangler at blive opdateret');

							

							self.submit(merge({}, self.entity), true);
						}
					},
					{
						label: 'Faktureret',
						action() {
							

							// Set invoice date
							//this.invoiced = 'true';

							self.submit(merge({}, self.entity), false, 'invoiced'); 
						}
					},
					{
						label: 'Bogført',
						action() {
							

							// Set invoice date
							//this.invoiced = 'true';

							self.submit(merge({}, self.entity), false, 'closed'); 
						}
					}
				];
			}
		},
		props: {
			id: Number,
			form: Boolean,
			submit: {
				type: Function,
				default: function (entity) { return true; }
			},
			value: {
				type: Object,
				default() {
					return {
						entity: {},
						orders: [],
						template: {
							template: ''
						}
					};
				}
			},
			lookup: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			onActionButtonClick(event) {
				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: this._actions
				});
			},
			inclInput(val, line) {
				if (val) {
					this.entity.template.incl.push(line);
				} else {
					this.entity.template.incl.splice(this.entity.template.incl.indexOf(line), 1);
				}
			},
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			async onAddButtonClick(sendToEcon) {
				const self = this;

				this.entity.order_ids = this.value.orders ? this.value.orders.map((val) => { return val.id; }) : [];
				//if (this.value.orders) this.value.orders.map((val) => { return val.id; });

				console.log('before submit');
				

				var model = await this.submit(merge({}, this.entity));

				console.log('print model', model);

				model.type = 'invoice';
				model.date = model.created;

				

				if (sendToEcon) {
					

					self.$store.state.windowStack.push(InvoiceWindow, {
						value: model, 
						submit: async function (inv) {
							self.axios.post('/integrations/economic/invoices/', {
								invoice: inv,
								order: model
							}).then(() => {
								// Close window here
								self.$store.state.windowStack.pop();
								bus.$emit('update');
							}, function (test) {
								
								alert('Fakturaen kunne ikke oprettes, måske der varenumrene ikke findes? (' + test.response.data.message + ')');
							});
						}
					});
				} else {
					// Close window here
					self.$store.state.windowStack.pop();
					bus.$emit('update');
				}
			},
			onSaveAndSetStatus() {
				

				// Set invoice date
				//this.invoiced = 'true';

				this.entity._embedded.orders = this.orders;

				this.submit(merge({}, this.entity), this.email, this.post); 
			},
			getInvoiceObj(obj) {
				if (obj._embedded.invoice_contact) {
					return this.getInvoiceObj(obj._embedded.invoice_contact);
				} else {
					return obj;
				}
			},
			setNumbers(obj) {
				

				// Use invoice concact numbers
				const inv = this.getInvoiceObj(obj);

				

				for (var i = 0; i < this.numbers.length; ++i) {
					var num = this.numbers[i];
					num.default = num.static ? num.value : '';
					num.name 	= num.label;
				}

				for (i = 0; i < inv.numbers.length; ++i) {
					if (this.numbers.filter((item) => {
						return item.name == inv.numbers[i].label;
					}).length == 0) {
						this.numbers.push({
							name: 		inv.numbers[i].label,
							label: 		inv.numbers[i].label,
							default: 	inv.numbers[i].static ? inv.numbers[i].value : ''
						});
					}
				}

				
			},
			selectCustomer(obj) {
				
				this.numbers = obj.numbers; // Union

				this.setNumbers(obj);

				this.entity = merge(this.entity, {
					customer: {
						name: obj.name,
						address: {
							address: 	obj.address,
							zip: 		obj.zip,
							city: 		obj.city,
							country: 	obj.country
						},
						phone: obj.phone,
						email: obj.email,
						numbers: {
							vat:		obj.roles.business ? obj.roles.business.vat : '',
							ean:		obj.roles.business ? obj.roles.business.ean : ''
						}
					}
				});

				this.prices = obj._embedded.prices;
			},
			onSaveAndInvoiceButtonClick() {
				

				this.submit(merge({}, this.entity), true);
			}
		},
		mounted: async function() {
			

			const self = this;

			console.log('New invoice window mounted 2', this.value.entity);

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
				});

			this.entity = merge(this.entity, this.value.entity);

			// Handle order lines
			if (this.value.template) 	this.entity.template = this.value.template;
			if (this.value.orders) 		this.entity.order_lines = this.value.orders.reduce((c, val) => { return c.concat(val.order_lines); }, []);

			





			// Load hours
			this.hours = [];
			let orderCalls = [];
			//let hoursCalls = [];

			if (this.value && this.value.orders) {
				for (const order of this.value.orders) {
					orderCalls.push(this.axios.get(`/sales/orders/${order.id}`));
				}
			}	

			Promise.all(orderCalls).then((rs) => {
				

				for (const r of rs) {
					for (const task of r.data._embedded.tasks) {
						let h = 0;

						for (const emp of task._embedded.hours.union) {
							h += emp.hours;
						}

						self.hours.push({
							label: `${this.$options.filters.number(parseFloat(h))} timer (Opgave #${task.num}${ task.closed ? `, ${self.$options.filters.timestamp(task.closed)}` : '' })`,
							hours: Math.round(parseFloat(h) * 100.) / 100.
						});
					}
				}

				
			});





			

			

			if (this.entity.contact_id !== null) {
				var obj = await ContactModel.read(this.axios, this.entity.contact_id);

				if (obj.invoice_text) {
					this.entity.remarks = obj.invoice_text;
				}

				this.selectCustomer(obj);
			}

			/*
			
			

			var self = this;

			this.entity = merge(OrderModel.entity(), this.value);

			// Remove approvals from no-id
			if (!this.entity.hasOwnProperty('id') || this.entity.id === null) {
				
				this.entity._embedded.approvals = [];
			} else {
				
			}

			

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/sales/orders/status/')
				.then(function (r) {
					self.status = r.data._items;
				});

			this.axios
				.get('/templates/orders/')
				.then(function (r) {
					self.templates = r.data._items;
				});

			

			if (this.entity.contact_id !== null) {
				

				var obj = await ContactModel.read(this.axios, this.entity.contact_id);

				this.selectCustomer(obj);

			
			}*/
		}
	}
</script>

<style lang="scss">
	
</style>
